import { lazy } from 'react';

const LoadableBannedUserModal = lazy(
  () => import(/* webpackChunkName: "damz-modals" */ './ReactionLimitModal')
);

export default LoadableBannedUserModal;
